export enum EItemRecurrenceEditType {
  onlyThis = 'onlyThis',
  thisAndFollowing = 'thisAndFollowing',
  all = 'all',
}

export enum ERecursiveAction {
  edit = 'edit',
  delete = 'delete',
}
